
export default function Footer() {
    return (
        <div className="bg-gray-700">
            <div className="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between flex-wrap">
                    <div className="w-0 flex-1 flex items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7" viewBox="0 0 20 20" fill="#ff78fa">
                            <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" />
                        </svg>
                        <p className="ml-3 font-medium text-white text-center">
                            <span>Made by <a href="https://github.com/euhidaman">Euhid Aman</a> , <a href="https://github.com/sakshi-singh-1011">Sakshi Singh</a> & <a href="https://github.com/TinaaaaP">Tina Pu</a> </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}
